import React from 'react'
import './footer.css'
function Footer() {
  return (
    <div className="f"></div>
  )
}

export default Footer